import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { paths } from '@/utils/path'
import AddIcons from '@/icons/AddIcons'
import { useSupplierList } from '../../hooks/use-supplier-list'

const SuppliersList = () => {
    const {
        suppliers,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        searchInputProps,
        columns,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        handleCreate,
    } = useSupplierList()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.warehouse,
                        title: 'Capacities & Resources',
                    },
                    {
                        path: paths.warehouseSuppliers,
                        title: 'Suppliers',
                    },
                ]}
                actions={[
                    {
                        icon: <AddIcons />,
                        label: 'New Supplier',
                        onClick: handleCreate,
                    },
                ]}
            />

            <Paper className="mt-2 space-y-2">
                <FilterBar
                    storageKey="warehouse-suppliers"
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={suppliers}
                        rowKey={(row) => row.id}
                        size="small"
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: 'Search suppliers...',
                            },
                            settings: {
                                show: true,
                                storageKey: 'warehouse-suppliers',
                                filterToggles,
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </>
    )
}

export default SuppliersList
